import script from "./receive.vue?vue&type=script&setup=true&lang=js"
export * from "./receive.vue?vue&type=script&setup=true&lang=js"

import "./receive.vue?vue&type=style&index=0&id=f4edb2d8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4edb2d8"]])

export default __exports__